import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
  Form,
  FormControl,
  FormControlProps,
  FormGroup,
} from 'react-bootstrap';
import {
  formatCardNumber,
  formatExpirationDate,
  formatPhone,
} from '../../utils/utils';

export type TextInputVariant =
  | 'text'
  | 'password'
  | 'email'
  | 'tel'
  | 'url'
  | 'card'
  | 'expiration'
  | 'cvc';

export type TextInputProps = FormControlProps & {
  label?: string;
  placeholder?: string;
  leftIcon?: IconProp;
  rightIcon?: IconProp;
  type?: string;
  name?: string;
  labelIcon?: boolean;
  maxLength?: number;
};

const TextInput: React.FC<TextInputProps> = ({
  label,
  placeholder,
  leftIcon,
  rightIcon,
  type = 'text',
  disabled,
  value,
  onChange,
  isValid,
  isInvalid,
  className,
  name,
  labelIcon = false,
  onKeyDown,
  ...props
}) => {
  const setIcon = (iconName: IconProp, side: string) => (
    <FontAwesomeIcon icon={iconName} className={`icon ${side}`} />
  );

  const phoneFormater = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const inputValue = e.currentTarget;
    const formattedValue = formatPhone(inputValue.value);

    inputValue.value = formattedValue;
  };

  const cardFormater = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const inputValue = e.currentTarget;
    const formattedValue = formatCardNumber(inputValue.value);

    inputValue.value = formattedValue;
  };

  const expirationDateFormater = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const inputValue = e.currentTarget;
    const formattedValue = formatExpirationDate(inputValue.value);

    inputValue.value = formattedValue;
  };

  const formatInput = (type: string, value: any) => {
    switch (type) {
      case 'tel':
        return phoneFormater(value);
      case 'card':
        return cardFormater(value);
      case 'expiration':
        return expirationDateFormater(value);
      default:
        return undefined;
    }
  };

  const maxLengthFormat = (type: any) => {
    switch (type) {
      case 'tel':
        return 14;
      case 'card':
        return 19;
      case 'expiration':
        return 5;
      case 'cvc':
        return 3;
      default:
        return undefined;
    }
  };

  return (
    <FormGroup className={`${className ? className : ''} text-input-custom`}>
      {label && (
        <Form.Label className={`${disabled ? 'disabled' : ''}`}>
          {label}
          {labelIcon && (
            <span className="px-6 label-icon">
              <FontAwesomeIcon icon={light('circle-exclamation')} />
            </span>
          )}
        </Form.Label>
      )}
      <div className={`input-wrapper`}>
        {leftIcon && setIcon(leftIcon, 'icon--left')}
        {rightIcon && setIcon(rightIcon, 'icon--right')}
        <FormControl
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          isValid={isValid}
          isInvalid={isInvalid}
          disabled={disabled}
          onKeyDown={(e) => formatInput(type, e)}
          maxLength={maxLengthFormat(type)}
          {...props}
        />
      </div>
    </FormGroup>
  );
};

export default TextInput;
